'use client';

import React, { useEffect, useState } from 'react';
import { AUTH_API_BASE_URL } from '@/lib/api/config';

type Probe = { name: string; url: string; ok: boolean; status?: number; error?: string };

const PROBE_INTERVAL_MS = 12_000;

export default function HrmUpstreamHealthBanner() {
  const [hrmDown, setHrmDown] = useState<boolean | null>(null);

  useEffect(() => {
    const base = AUTH_API_BASE_URL.replace(/\/+$/, '');
    const url = `${base}/gateway/health/upstreams`;
    let cancelled = false;

    const probe = async () => {
      try {
        const res = await fetch(url, { cache: 'no-store' });
        const json = (await res.json()) as { probes?: Probe[] };
        const hrm = json.probes?.find((p) => p.name === 'hrm-service');
        if (!cancelled) setHrmDown(!(hrm?.ok ?? false));
      } catch {
        if (!cancelled) setHrmDown(null);
      }
    };

    void probe();
    const timer = window.setInterval(() => {
      void probe();
    }, PROBE_INTERVAL_MS);

    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, []);

  if (hrmDown !== true) return null;

  return (
    <div
      className="mx-4 mt-4 lg:mx-6 rounded-xl border border-amber-300 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/50 px-4 py-3 text-sm text-amber-950 dark:text-amber-100"
      role="status"
    >
      <p className="font-semibold">HRM API service is not running</p>
      <p className="mt-1 text-xs leading-relaxed">
        Dashboard and employee screens need <strong>hrm-service</strong> on port{' '}
        <code className="bg-white/60 dark:bg-black/30 px-1 rounded">65309</code>. In{' '}
        <code className="bg-white/60 dark:bg-black/30 px-1 rounded">IQ_Central_Hub_API</code> run:{' '}
        <code className="bg-white/60 dark:bg-black/30 px-1 rounded">pnpm dev:hrm</code> or{' '}
        <code className="bg-white/60 dark:bg-black/30 px-1 rounded">pnpm dev:all</code>. Auth login
        and permission sync alone are not enough — the gateway returns Bad Gateway until HRM is up.
        This banner refreshes automatically every few seconds.
      </p>
    </div>
  );
}
